export default function InputCompanyName() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            model: "=",
            validation: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            // Default value
            $scope.label = "Virksomheds navn";

            // if ($scope.model.customerTypeID == 15) {
            //     $scope.label = "Offentlig navn";
            // }
        },
    };
}
